export default {
  getQuery(filtro: any) {
    const params = [];

    for (const atributo in filtro) {
      if (Object.prototype.hasOwnProperty.call(filtro, atributo)
      && filtro[atributo] !== undefined
      && filtro[atributo] !== null
      && filtro[atributo] !== '') {
        params.push(`${atributo}=${filtro[atributo]}`);
      }
    }
    return params.length > 0 ? `?${params.join('&')}` : '';
  },
};
